module.exports = __webpack_public_path__ + "img/signbefore.5a945f6b.jpg";